import { useOrgSelection } from "@/context/use-org-selection";

/**
 * Placeholder. Map configuration currently lives in the dashboard
 * (`src/features/locations/.../location-details.tsx`, `/settings/locations`)
 * and will move here — migrating it is out of scope for the scaffolding.
 */
export const MapConfiguration = () => {
	const { selected } = useOrgSelection();

	return (
		<section>
			<h2 className="text-primary text-base font-semibold">
				Map Configuration
			</h2>
			<p className="text-secondary mt-2 text-sm">
				Coming soon
				{selected ? ` — configuring ${selected.name}.` : "."}
			</p>
		</section>
	);
};
